import { toCapitalizeFirstLetter } from '@loadsmart/utils-string'

import { type Option } from 'core/domain/Option'
import { formatLocationOrAnywhere } from 'core/presenters/stopPresenter'
import { getTruckLabel } from 'core/presenters/truckPresenter'
import { toArray } from 'core/utils/array'
import { formatDate, parseISO } from 'core/utils/date'
import { isString } from 'core/utils/string'

import { type AgnosticShipmentFilter } from '../domain/AgnosticShipmentFilter'

export function formatEquipment({ equipment }: AgnosticShipmentFilter): string {
  return toArray(equipment).map(getTruckLabel).sort().join(', ')
}

export function formatLane({ pickup, delivery }: AgnosticShipmentFilter): string {
  if (pickup == null && delivery == null) {
    return ''
  }

  return `${formatLocationOrAnywhere(pickup)} → ${formatLocationOrAnywhere(delivery)}`
}

export function formatMode({ mode }: AgnosticShipmentFilter): string {
  return toArray(mode).slice().sort().join(', ')
}

export function formatPeriod({
  pickupDateAfter,
  pickupDateBefore,
}: AgnosticShipmentFilter): string {
  return [pickupDateAfter, pickupDateBefore]
    .filter(isString)
    .map(value => formatDate(parseISO(value), 'MM/dd/yyyy'))
    .join(' → ')
}

export function formatShipper(shipperOptions?: Array<Option<number>>): string {
  return toArray(shipperOptions)
    .map(({ label }) => label)
    .sort()
    .join(', ')
}

export function formatStatus({ status }: AgnosticShipmentFilter): string {
  return toArray(status).map(toCapitalizeFirstLetter).sort().join(', ')
}
